import styled from '@emotion/styled'

export const Bold = styled.b`
  color: #1890ff;
`
